<div [class]="inner_div_class + ' inner_div'" [class.has-notifications]="hasUnreadMentions">
  <ng-content></ng-content>
  @if (unreadCount > 0) {
    <span class="mention-badge" [attr.aria-label]="unreadCount + '件の未読'">{{ unreadCount > 99 ? '99+' : unreadCount }}</span>
  }
</div>
